window.init_loan=function(){
  // console.log("sdffffffffffffffffffffffffff")
  if($('.category_list0').is(':disabled')){
    $('.category_list9').click();
  }else{
    $('.category_list0').click();
  }
  var $active = $('#accordion .panel-collapse.in').prev().addClass('active');
  $active.find('a').prepend('<i class="glyphicon glyphicon-minus"></i>');
  $('#accordion .panel-heading').not($active).find('a').prepend('<i class="glyphicon glyphicon-plus"></i>');
  $('#accordion').on('show.bs.collapse', function (e) {
      $('#accordion .panel-heading.active').removeClass('active').find('.glyphicon').toggleClass('glyphicon-plus glyphicon-minus');
      $(e.target).prev().addClass('active').find('.glyphicon').toggleClass('glyphicon-plus glyphicon-minus');
  });

  $('.faq > ul > li > a').click(function(){

  if($(this).next('div').hasClass("active")){
    $('.faq ul li > div').hide();
    $('.faq ul li > div').removeClass('active');
  }else{
    $('.faq ul li > div').hide();
    $('.faq ul li > div').removeClass('active');
    $(this).next('div').toggle('slow');
    $(this).next('div').addClass('active');

  }

  });





  $('.inside_accordian ul li > a').click(function(){

  if($(this).next('.caption').hasClass("active1")){
    $('.inside_accordian ul li > .caption ').hide();
    $('.inside_accordian ul li > .caption').removeClass('active1');
  }else{
    $('.inside_accordian ul li > .caption').hide();
    $('.inside_accordian ul li > .caption').removeClass('active1');
    $(this).next('.caption').toggle('slow');
    $(this).next('.caption').addClass('active1');

  }

  });
// if(($("#sunnn").val()) === 'true')
// {
//   console.log("sunnnnnnnnnnnn")
//   $("input").prop("disabled", true);
// }
// console.log("ddddddddddddddd")
}
